const flexDirectionValues = [
  'row',
  'column',
  'row-reverse',
  'column-reverse',
] as const;

type FlexDirection = (typeof flexDirectionValues)[number];

function generateFlexDirectionVariants() {
  return flexDirectionValues.reduce(
    (acc, value) => {
      if (value === 'row') {
        acc[value] = 'flex-row';
      } else if (value === 'column') {
        acc[value] = 'flex-col';
      } else if (value === 'row-reverse') {
        acc[value] = 'flex-row-reverse';
      } else {
        acc[value] = 'flex-col-reverse';
      }
      return acc;
    },
    {} as Record<FlexDirection, string>,
  );
}

const flexVariants = {
  flexDirection: generateFlexDirectionVariants(),
  flexWrap: {
    nowrap: 'flex-nowrap',
    wrap: 'flex-wrap',
    'wrap-reverse': 'flex-wrap-reverse',
  },
  items: {
    start: 'items-start',
    end: 'items-end',
    center: 'items-center',
    baseline: 'items-baseline',
    stretch: 'items-stretch',
  },
  justify: {
    start: 'justify-start',
    end: 'justify-end',
    center: 'justify-center',
    between: 'justify-between',
    around: 'justify-around',
    evenly: 'justify-evenly',
  },
  flex: {
    '1': 'flex-1',
    auto: 'flex-auto',
    initial: 'flex-initial',
    none: 'flex-none',
  },
  grow: {
    0: 'grow-0',
    1: 'grow',
  },
  shrink: {
    0: 'shrink-0',
    1: 'shrink',
  },
  self: {
    auto: 'self-auto',
    start: 'self-start',
    end: 'self-end',
    center: 'self-center',
    stretch: 'self-stretch',
    baseline: 'self-baseline',
  },
  order: {
    1: 'order-1',
    2: 'order-2',
    3: 'order-3',
    4: 'order-4',
    5: 'order-5',
    6: 'order-6',
    7: 'order-7',
    8: 'order-8',
    9: 'order-9',
    10: 'order-10',
    11: 'order-11',
    12: 'order-12',
    first: 'order-first',
    last: 'order-last',
    none: 'order-none',
  },
} as const;

type FlexVariants = typeof flexVariants;

export { type FlexDirection, type FlexVariants, flexVariants };
